<template>
  <div>
    <div v-if="isLoading" class="d-flex justify-content-center h-100 align-items-center">
      <b-spinner class="align-middle" variant="secondary" />
    </div>
    <div v-else-if="posts.length === 0">
      <div class="row">
        <div class="col-12 text-center">
          <img clas="icon" src="/images/course/voto-pessimo.svg" class="img-fluid img-not-found" />
        </div>
        <div class="col-12 text-center">
          <p class="mt-3">{{ trans("community.no_post_found") }}</p>
        </div>
      </div>
    </div>
    <div v-else class="posts-list">
      <post-card
        v-for="post in this.posts"
        :key="post.id"
        :poster-id="post.user_id"
        :is-user-post="post.can_edit === 1 ? true : false"
        :display-name="post.display_name"
        :date="post.created_at"
        :description="post.title"
        :title="post.description"
        :post-id="post.id"
        :reaction="post.reaction"
        :likes="post.likes"
        :color="post.color"
        :delete-post="onDeletePost"
        :edit-post="onEditPost"
        :like-post="onLikePost"
        hasComments
        :commentsLength="post.comments.length"
      >
        <template v-slot:translations>
          <post-translation-container
            :post-id="post.id"
            :title-locale="post.title_locale"
            :description-locale="post.description_locale"
          />
        </template>
        <comments-box
          @onCommentSubmit="onCommentSubmited"
          :post-id="post.id"
          :comments="post.comments"
        />
      </post-card>

      <div
        v-if="this.currentPage !== this.lastPage"
        @click="loadMorePosts()"
        class="text-primary text-bold d-flex justify-content-center mt-5"
      >
        <b-link class="btn text-primary">{{ trans("community.other_posts") }}</b-link>
      </div>
    </div>

    <b-modal
      id="edit-post-modal"
      header-class="no-border"
      centered
      hide-footer
      ref="edit-post-modal"
    >
      <template v-slot:modal-header="{ close }">
        <p class="text-primary text-bold">{{ trans("community.add_your_post") }}</p>
        <b-icon
          icon="x"
          v-on:click="close()"
          scale="2"
          class="close-button"
          variant="primary"
        ></b-icon>
      </template>
      <div class="row">
        <div class="col-12">
          <create-post-form :post-data="postToEdit" @onEditedPost="onEditedPost" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PostCard from "../../molecules/cards/PostCard";
import CommentsBox from "../../molecules/CommentsBox";
import PostTranslationContainer from "../../organisms/PostTranslationContainer";
import CreatePostForm from "../../organisms/community/CreatePostForm";

export default {
  name: "CommunityPostsContent",
  components: { PostCard, CommentsBox, CreatePostForm, PostTranslationContainer },
  props: {
    posts: Array,
    isLoading: Boolean,
    currentPage: Number,
    lastPage: Number,
  },
  data() {
    return {
      postToEdit: {},
    };
  },
  methods: {
    loadMorePosts() {
      this.$emit("loadMorePosts");
    },
    getPostById(postId) {
      return this.posts.filter(function (post) {
        return post.id === postId;
      });
    },
    onDeletePost(postId) {
      this.$axios
        .delete(`/api/rest/community/post/${postId}`)
        .then((res) => {
          const postToDelete = this.getPostById(postId);
          const postIndex = this.posts.indexOf(...postToDelete);

          this.posts.splice(postIndex, 1);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onEditPost(postId) {
      const postToEdit = this.posts.find((post) => post.id === postId);
      const postDataCopy = _.cloneDeep(postToEdit);
      this.postToEdit = postDataCopy;
      this.$refs["edit-post-modal"].show();
    },
    onEditedPost(postData) {
      this.$axios
        .put(`/api/rest/community/post/${postData.id}`, postData)
        .then((res) => {
          this.$refs["edit-post-modal"].hide();
          const postToUpdate = this.posts.find((post) => post.id === postData.id);
          postToUpdate.title = res.data.data[0].title;
          postToUpdate.description = res.data.data[0].description;
          postToUpdate.color = res.data.data[0].color;
          postToUpdate.color_bkg_title = res.data.data[0].color_bkg_title;
          postToUpdate.private = res.data.data[0].private;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onLikePost(postId) {
      this.$axios
        .post(`/api/rest/community/post/${postId}/reaction`, {
          post_id: postId,
          reaction_type: "like",
        })
        .then((res) => {
          const likedPost = this.posts.find((post) => post.id === postId);
          likedPost.likes = Number(res.data);
          likedPost.reaction === null ? (likedPost.reaction = "like") : (likedPost.reaction = null);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onCommentSubmited(value) {
      this.$axios
        .post(`/api/rest/community/post/${value.postId}/comment`, {
          post_id: value.postId,
          comment_text: value.comment,
        })
        .then((res) => {
          const commentedPost = this.posts.find((post) => post.id === value.postId);
          commentedPost.comments.unshift(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.posts-list {
  .card {
    &:first-child {
      margin-top: 0 !important;
    }
    margin-top: $spacer * 1.5 !important;
  }
}
</style>
